/**
 * Handshake bootstrap (§4 step 3, §4.1).
 *
 * The SPA loads with `?t=<token>`. In dev with no legacy parent, fall back to the
 * build-time VITE_DEV_AUTH_TOKEN so the flow works against `vite dev`. POST it to
 * /api/auth/session; the backend validates, enforces utype==1, and sets the
 * httpOnly session cookie. The token is single-use — strip it from the URL after.
 */
import { ApiError } from "./client.js";

export async function establishSession(): Promise<{ org: number }> {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("t") ?? import.meta.env.VITE_DEV_AUTH_TOKEN;
  if (!token) throw new ApiError(401, "no handshake token");

  const res = await fetch("/api/auth/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ token }),
  });
  // 403 = not an internal user (utype != 1) → AccessDenied; other failures → generic error.
  if (!res.ok) throw new ApiError(res.status, `session handshake failed: ${res.status}`);

  // Drop the single-use token from the address bar.
  params.delete("t");
  const clean = window.location.pathname + (params.toString() ? `?${params}` : "");
  window.history.replaceState({}, "", clean);

  return (await res.json()) as { org: number };
}
